import { render, staticRenderFns } from "./organizationCreditNote.vue?vue&type=template&id=5c38080b&"
import script from "./organizationCreditNote.vue?vue&type=script&lang=js&"
export * from "./organizationCreditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports